// แปลงหน่วย
import { GetCorService, genURL } from "./../_getjson";
import axios from 'axios'
export function checkunit1(Code) {
    var url = "CSUNIT/ByCode?code=" + Code;
    return GetCorService(url).then(res => {
        if (res.data.length > 0) {
            return res.data[0].MYNAMETH
        }
    }).catch(error => {
        console.log(error);
    });
}
export const checkunit = async (code) => {
    var textreturn = "";
    var url = "CSUNIT/ByCode?code=" + code;
    console.log("urlcheckunit", genURL(url));
    await axios.get(genURL(url), { timeout: 5000 }).then(res => {
        for (var i = 0; i < res.data.length; i++) {
            textreturn = res.data[i].MYNAMETH
        }
    })
    return await textreturn
}
export const department = async (col) => {
    var textreturn = "";
    var url = "CSDEPARTMENT/ByCode?code=" + col + "&user=" + sessionStorage.getItem("Username");
    console.log(genURL(url));
    await axios.get(genURL(url), { timeout: 5000 } ).then((res) => {
        for (var i = 0; i < res.data.length; i++) {
            textreturn = res.data[i].MYNAMETH
        }
    }).catch(error => {
        console.log(error);
    });
    return await textreturn
}
export const branch = async (code) => {
    var textreturn = "";
    var url = "CSSITE/Getsite?Code=" + code + "&user=" + sessionStorage.getItem("Username");
    console.log(genURL(url));
    await axios.get(genURL(url), { timeout: 5000 }).then(res => {
        for (var i = 0; i < res.data.length; i++) {
            textreturn = res.data[i].MYNAMETH
        }
    }).catch(error => {
        console.log(error);
    });
    return await textreturn
}